<h1 mat-dialog-title>Seguir nueva norma {{ title.value }}</h1>
<div mat-dialog-content class="container">
  <form class="form-container" #form="ngForm" [formGroup]="formGroup">
    <mat-form-field class="form-field">
      <mat-label>Nombre</mat-label>
      <input autocomplete="off" matInput type="text" formControlName="title" required />
      <button mat-button matSuffix mat-icon-button (click)="title.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
      <mat-hint>Escriba el nombre descriptivo de la norma que aparecerá en el calendario.</mat-hint>
      <mat-error *ngIf="title.invalid">
        <span *ngIf="title.errors.required || title.invalid">Campo requerido.</span>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="form-field">
      <mat-label>URL</mat-label>
      <input autocomplete="off" matInput type="text" formControlName="url" required placeholder="https://" />
      <button mat-button matSuffix mat-icon-button (click)="url.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
      <mat-hint>Inserte la url de la iniciativa a seguir en la página del congreso.</mat-hint>
      <mat-error *ngIf="url.invalid">
        <span *ngIf="url.errors.required || url.invalid">Campo requerido.</span>
      </mat-error>
    </mat-form-field>
  </form>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions>
  <button mat-flat-button (click)="onNoClick()" color="warn">Cancelar</button>
  <button mat-flat-button (click)="addNorm()" cdkFocusInitial color="primary">Guardar</button>
</div>
